import React from 'react';
import { ConfigProvider } from 'antd';
import { observer, inject } from 'mobx-react';
import { Inspector } from 'react-dev-inspector';
import * as Sentry from '@sentry/react';
import en_US from 'antd/lib/locale/en_US';
import zh_CN from 'antd/lib/locale/zh_CN';
import 'moment/locale/zh-cn';
import Container from '@/router';
import locales from '@/locales';
import commonLocales from '&/locales';
import { enUSStr, zhCNStr } from '@/constants';
import LoadingComponent from '&/components/LoadingComponent';
const merge = require('lodash/merge');

export default inject('appStore')(
    observer(function App(props) {
        let { appStore } = props;
        let antdLocales = {
            [enUSStr]: en_US,
            [zhCNStr]: zh_CN,
        };

        if (window.location.href.includes('zxtest=1')) {
            let flag = new Date().getTime();
            Sentry.withScope(function (scope) {
                scope.setFingerprint(['{{ default }}', 'zxtest-11-12-', flag]);
                Sentry.captureException(new Error('zxtest-12-13-' + flag));
            });
            // throw new Error('zxtest-11-12'+ new Date().getTime());
        }

        initI18(appStore);

        const content = (
            <ConfigProvider locale={antdLocales[appStore.lang]}>
                <LoadingComponent>
                    <Container />
                </LoadingComponent>
            </ConfigProvider>
        );

        // 页面聚焦后，同时按住键盘qwe按键，就可以在页面选取要查看的组件了。选取好后点击，就会自动打开VS Code 定位到该组件的文件
        const app =
            process.env.NODE_ENV === 'development' ? (
                <Inspector keys={['q', 'w', 'e']}>{content}</Inspector>
            ) : (
                content
            );

        return app;
    })
);

function initI18(appStore) {
    let { lang } = appStore;

    //intl
    intl.init({
        currentLocale: lang, // TODO: determine locale here
        locales: {
            [enUSStr]: merge(commonLocales[enUSStr], locales[enUSStr]),
            [zhCNStr]: merge(commonLocales[zhCNStr], locales[zhCNStr]),
        },
        warningHandler: message => {
            if (!message.includes('tdk.')) {
                console.warn(message);
            }
        },
    });

    //moment

    return lang;
}
